import React, {useState, useEffect, useContext} from 'react';
import styles from './home.module.css';
import infoIcon from '../../assets/images/infoIcon.PNG';
import {useTranslation} from 'react-i18next';
import MenuContext from '../../context/menuContext';

function HomeContent({title, number, unit}) {
  const {ceiling, floor, millisec} = number;
  const [value, setValue] = useState(82);
  const {setShowAck, alert, sensorError, showAck, showInfo, setInfo, info, onComponent} =
    useContext(MenuContext);
  useEffect(() => {
    const interval = setInterval(
      () => setValue(Math.floor(Math.random() * ceiling + floor)),
      millisec,
    );

    return () => {
      clearInterval(interval);
    };
  }, []);

  const {t, i18n} = useTranslation();

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <div className={styles.top}>
        <img
          className={alert && info && !sensorError ? styles.infoIcon : styles.infoIconHide}
          src={infoIcon}
          alt="information"
        />
        <span className={styles.topText}>
          {title === 'Mass Flow Rate'
            ? t('screen.header')
            : title && title === 'Drive Gain'
            ? t('screen.menu_btn.list.item4.c3.i1.c2.i1.s3')
            : title && title === 'Temperature'
            ? t('screen.menu_btn.list.item4.c1.p4.title')
            : title && title === 'Density'
            ? t('screen.menu_btn.list.item4.c1.p3.title')
            : title && title === 'Vol Fwd Total'
            ? t('screen.menu_btn.list.item3.o4.t4.s2.g1')
            : title && title === 'Volume Flow Rate'
            ? t('screen.menu_btn.list.item4.c1.p13.b1.g1.s2')
            : title && title === 'Mass Fwd Total'
            ? t('screen.menu_btn.list.item4.c1.p7.t1.title')
            : title}
        </span>
      </div>
      <div className={styles.randomContainer}>
        <h1 className={styles.randomNumber}>{title === 'Mass Flow Rate' ? value : number}</h1>
        <span className={styles.unit}>{unit}</span>
      </div>
    </>
  );
}

export default HomeContent;
